import type { ITextReplaceRule } from '@carboncopyco/types';

export const textReplaceDefaultValues: Partial<ITextReplaceRule> = {
  newValue: '',
  oldValue: '',
  options: {
    isCaseSensitive: false,
    isExactWord: true,
    applyOnUrls: ['*'],
  },
};
